import { Schema } from "effect"
import { HttpApiEndpoint, HttpApiGroup } from "effect/http-api"
import { Authentication } from "./AuthApi.ts"
import { InvalidDocument } from "./Errors.ts"

// Small per-user JSON documents: the chart workspace, each symbol's drawings.
// The server stores them as given; clients decode them with their own Schemas.

export const DocumentKey = Schema.String.pipe(Schema.check(Schema.isPattern(/^[A-Za-z0-9:._&-]{1,200}$/)))

export const StoredDocument = Schema.Struct({
  /** The document as JSON text, or null when it was never saved. */
  json: Schema.NullOr(Schema.String),
  updatedAt: Schema.NullOr(Schema.Number)
})
export type StoredDocument = typeof StoredDocument.Type

export class DocumentsApi extends HttpApiGroup.make("documents")
  .add(
    HttpApiEndpoint.get("get", "/:key", {
      params: { key: DocumentKey },
      success: StoredDocument
    }),
    HttpApiEndpoint.put("put", "/:key", {
      params: { key: DocumentKey },
      payload: Schema.Struct({ json: Schema.String }),
      success: Schema.Struct({ updatedAt: Schema.Number }),
      error: InvalidDocument
    })
  )
  .middleware(Authentication)
  .prefix("/documents")
{}
